import { useSessaoAtual } from '../../../services/providers/sessao-atual-provider/sessao-atual-provider'
import { Redirect, Route, RouteProps } from "react-router-dom";

type PrivateRouteProps = RouteProps & {
    isPrivate: boolean,
    checkIsInactive: boolean
}
export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, isPrivate, checkIsInactive, ...rest }) => {
    const { IsValidSession } = useSessaoAtual();

    const routeComponent = () => (
        isPrivate
            ? IsValidSession() === 1 || IsValidSession() === 2
                ? children
                : <Redirect to="/" />
            : checkIsInactive
                ? IsValidSession() === 0
                    ? children
                    : IsValidSession() === 1 ?
                        <Redirect to="/saurus-pdv" />
                        : <Redirect to="/representante/clientes" />
                : children
    )
    return (
        <Route {...rest} render={routeComponent} />
    );
}